var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"render-canvas",attrs:{"id":"babylon"}},[_c('div',{ref:"loadingScreen",staticClass:"loadingScreen"}),_c('canvas',{ref:"renderCanvas",attrs:{"id":"renderCanvas"},on:{"click":_vm.canvasclick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }